import { toHTML } from '../util/dom-util';
import EventHandler from '../_dependencyvendor/event-handler';

// eslint-disable-next-line no-unused-vars
const VERSION = '1.0.0';
const NAME = 'ui.toast';

const defaultConfig = {
  templateContainer: ``,
  templateBox: ``,
  lifeTime: 2000,
};

class Toast {
  constructor(config = {}) {
    this._config = {
      ...defaultConfig,
      ...Toast.GLOBAL_CONFIG,
      ...config,
    };
    this._toastBox = null;
  }

  static GLOBAL_CONFIG = {};
  static TOAST_HOLDER = null;
  static TOAST_COUNT = 0;

  static getContainer(template) {
    if (Toast.TOAST_HOLDER === null) {
      Toast.TOAST_HOLDER = toHTML(template);
      document.body.appendChild(Toast.TOAST_HOLDER);
    }
    return Toast.TOAST_HOLDER;
  }

  static get NAME() {
    return NAME;
  }

  show(message, isPopup = false) {
    this._show(message, isPopup);
  }

  _show(message, isPopup) {
    this._toastBox = toHTML(this._config.templateBox.replace('{{MESSAGE}}', message));
    Toast.getContainer(this._config.templateContainer).appendChild(this._toastBox);
    // eslint-disable-next-line no-unused-vars
    const reflow = this._toastBox.offsetHeight;
    this._toastBox.classList.add('is-active');
    console.log('isPopup', isPopup);
    if (isPopup) {
      this._toastBox.classList.add('is-popup');
    }
    Toast.TOAST_COUNT++;
    setTimeout(() => {
      this._hide();
    }, this._config.lifeTime);
  }

  _hide() {
    this._toastBox.classList.remove('is-active');
    this._toastBox.classList.add('is-deactive');
    EventHandler.one(this._toastBox, 'animationend', () => {
      Toast.getContainer(this._config.templateContainer).removeChild(this._toastBox);
      Toast.TOAST_COUNT--;
      if (Toast.TOAST_COUNT <= 0) {
        document.body.removeChild(Toast.TOAST_HOLDER);
        Toast.TOAST_HOLDER = null;
      }
    });
  }
}

export default Toast;
